<template>
  <div class="myorder">
    <tabbar v-show="page === '2' || page === '3'"></tabbar>
    <div class="login" v-if="page === '1'">
      <span>登录</span>
      <span>LOGIN</span>
      <el-form
        :model="ruleForm"
        status-icon
        ref="ruleForm"
        class="demo-ruleForm"
        label-width="1rem"
      >
        <div>
          <!--            手机号-->
          <div class="info-list-item">
            <div class="info_icon1">
              <img :src="nameList[1].icon" width="100%" height="100%" />
            </div>
            <el-form-item
              :label="nameList[1].title"
              prop="phoneNumber"
              :rules="[
                {
                  required: true,
                  message: '手机号不能为空',
                  trigger: 'blur'
                },
                {
                  pattern: /^1[0-9]{10}$/,
                  message: '手机号格式不对',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model.number="ruleForm.phoneNumber"
                maxlength="11"
                @blur="blur"
                placeholder="请输入手机号"
              ></el-input>
            </el-form-item>
          </div>
          <!--            身份证-->
          <div class="info-list-item" v-show="false">
            <div class="info_icon1">
              <img :src="nameList[2].icon" width="100%" height="100%" />
            </div>
            <el-form-item
              :label="nameList[2].title"
              prop="identifyCard"
              :rules="[
                {
                  required: true,
                  message: '身份证号不能为空',
                  trigger: 'blur'
                },
                {
                  pattern: /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
                  message: '身份证号格式不对',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model="ruleForm.identifyCard"
                maxlength="18"
                @blur="blur"
                placeholder="请输入身份证号"
              ></el-input>
            </el-form-item>
          </div>
          <div class="info-list-item info-list-item2">
            <div class="info_icon1">
              <img :src="nameList[3].icon" width="100%" height="100%" />
            </div>
            <el-form-item
              :label="nameList[3].title"
              prop="smsCode"
              :rules="[
                {
                  required: true,
                  message: '验证码不能为空',
                  trigger: 'blur'
                }
              ]"
            >
              <el-input
                v-model.number="ruleForm.smsCode"
                maxlength="6"
                @blur="blur"
                placeholder="验证码"
              ></el-input>
              <span
                v-show="sendAuthCode"
                class="smscode"
                @click="getVerificationCode"
                >获取验证码</span
              >
              <span class="smscode nosmscode" v-show="!sendAuthCode"
                >{{ auth_time }}S后重新获取</span
              >
            </el-form-item>
          </div>
        </div>
      </el-form>
      <el-button type="primary" @click="next">确定</el-button>
    </div>
    <mescroll-vue
      ref="mescroll"
      :down="mescrollDown"
      :up="mescrollUp"
      @init="mescrollInit"
      v-if="page === '2'"
    >
      <div class="order-page">
        <div class="tab">
          <span @click="switchNow" :class="isOpacity1">尚未开始</span>
          <span></span>
          <span @click="switchHistory" :class="isOpacity2">历史记录</span>
        </div>
        <div class="content" v-show="!history">
          <div class="column" ref="viewBox" v-for="(item, index) in dataList">
            <div class="wrapper">
              <span class="title">{{
                item.unit === true ? "团队预约" : "个人预约"
              }}</span>
              <span class="museum-title">{{ item.museumName }}</span>
              <span class="time">
                {{ item.ticketDate }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                  item.bookingData
                }}
              </span>
              <span class="details">
                <span class="yellow">{{ item.peopleName }}</span> 预约
                <span class="yellow">{{ item.peopleNumber }}</span> 张门票
              </span>
              <div class="button" @click="look(index)">查看</div>
            </div>
          </div>
        </div>
        <div class="content" v-show="history">
          <div class="column" ref="viewBox" v-for="(item, index) in dataList">
            <div class="wrapper">
              <span class="title">{{
                item.unit === true ? "团队预约" : "个人预约"
              }}</span>
              <span class="museum-title">{{ item.museumName }}</span>
              <span class="time">
                {{ item.ticketDate }}&nbsp;&nbsp;&nbsp;&nbsp;{{
                  item.bookingData
                }}
              </span>
              <span class="details">
                <span class="yellow">{{ item.peopleName }}</span> 预约
                <span class="yellow">{{ item.peopleNumber }}</span> 张门票
              </span>
              <div class="button disabled">完成</div>
            </div>
          </div>
        </div>
      </div>
    </mescroll-vue>

    <div class="order-details" v-if="page === '3'">
      <span class="time">{{ dataList[number].ticketDate }}</span>
      <div class="column" v-if="dataList[number].unit === true">
        <div class="wrapper">
          <span class="title">参观信息</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/time.png" width="100%" height="100%" />
            </div>
            <p>参观时间</p>
          </span>
          <span class="value">{{ dataList[number].bookingData }}</span>
          <span class="info_title">
            <div class="info_icon">
              <img
                src="@/assets/icons/jiangjie.png"
                width="100%"
                height="100%"
              />
            </div>
            <p>讲解员</p>
          </span>
          <span class="value">{{
            dataList[number].commentator === true ? "是" : "否"
          }}</span>
        </div>
      </div>
      <div class="column" v-if="dataList[number].unit === true">
        <div class="wrapper">
          <span class="title">团体信息</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/group.png" width="100%" height="100%" />
            </div>
            <p>团体概况</p>
          </span>
          <span class="value">{{ dataList[number].unitProperty }}</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/name.png" width="100%" height="100%" />
            </div>
            <p>参观人数</p>
          </span>
          <span class="value">{{ dataList[number].peopleNumber }}</span>
        </div>
      </div>
      <div class="column">
        <div class="wrapper">
          <span class="title">
            {{
              dataList[number].unit === "团队预约" ? "负责人信息" : "预约人信息"
            }}
          </span>
          <span class="qrcode" @click="getTicket" v-show="false">
            <img src="@/assets/icons/qrcode.png" width="100%" height="100%" />
          </span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/name.png" width="100%" height="100%" />
            </div>
            <p>姓名</p>
          </span>
          <span class="value">{{ dataList[number].peopleName }}</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/idcard.png" width="100%" height="100%" />
            </div>
            <p>身份证号</p>
          </span>
          <span class="value">{{ dataList[number].identifyCard }}</span>
          <span class="info_title">
            <div class="info_icon">
              <img src="@/assets/icons/phone.png" width="100%" height="100%" />
            </div>
            <p>手机号</p>
          </span>
          <span class="value">{{ dataList[number].phoneNumber }}</span>
        </div>
      </div>
      <mt-popup
        v-model="remindShow"
        position="bottom"
        popup-transition="popup-fade"
      >
        <div class="popup">
          <span class="popup-title">提醒</span>
          <span>一经确认，无法修改，如有变更，请取消预约后重新预约。</span>
          <el-button @click="cancelTicket">确定</el-button>
        </div>
      </mt-popup>
      <mt-popup
        v-model="qrcodeShow"
        position="bottom"
        popup-transition="popup-fade"
      >
        <div class="popup">
          <span class="popup-title">取票二维码</span>
          <qrcode
            :identifyCard="dataList[number].identifyCard"
            :ticketDate="dataList[number].ticketDate"
          ></qrcode>
          <span>请于取票机扫码自助取票</span>
          <el-button @click="returnOrder">确定</el-button>
        </div>
      </mt-popup>
      <div :class="[position1, { position2: dataList[number].unit === true }]">
        <div class="button" @click="returnList">返回列表</div>
        <div class="button" @click="remind">取消预约</div>
      </div>
    </div>
  </div>
</template>
<script>
import MescrollVue from "mescroll.js/mescroll.vue";
import tabbar from "@/components/tabBar/tabBar";

export default {
  name: "myOrder",
  components: {
    MescrollVue, // 注册mescroll组件
    tabbar
  },
  data() {
    return {
      remindShow: false, //是否显示提醒
      qrcodeShow: false, //是否显示取票二维码
      ruleForm: {
        phoneNumber: "",
        identifyCard: "",
        smsCode: "" //验证码
      },
      nameList: [
        {
          title: "姓名",
          icon: "./static/images/icons/name.png",
          text: ""
        },
        {
          title: "手机号",
          icon: "./static/images/icons/phone.png",
          text: ""
        },
        {
          title: "身份证号",
          icon: "./static/images/icons/idcard.png",
          text: ""
        },
        {
          title: "验证码",
          icon: "./static/images/icons/smsCode.png",
          text: ""
        }
      ],
      page: "1",
      openingTime: "1",
      openingTimeRemarks: "李四 预约 10 张门票",
      history: false,
      isOpacity1: "",
      isOpacity2: "opacity",
      endList: [], //历史订单
      noStartList: [], //未开始订单
      number: "1", //订单索引
      status: "完成", //订单状态
      position1: "button-group",
      position2: "button-group2",
      sendAuthCode: true /*布尔值，通过v-show控制显示‘获取按钮’还是‘倒计时’ */,
      auth_time: 30 /*倒计时 计数器*/,
      type: "noEnd", //订单
      // 分页功能
      totalPage: [],
      // 每页显示数量
      pageSize: 3,
      // 共几页
      pageNum: 0,
      // 当前显示的数据
      dataList: "",
      // 默认当前显示第一页
      currentPage: 1,
      mescroll: null, // mescroll实例对象
      mescrollDown: {}, //下拉刷新的配置. (如果下拉刷新和上拉加载处理的逻辑是一样的,则mescrollDown可不用写了)
      mescrollUp: {
        // 上拉加载的配置.
        callback: this.upCallback, // 上拉回调,此处简写; 相当于 callback: function(page, mescroll) { }
        //以下是一些常用的配置,当然不写也可以的.
        page: {
          num: 0, //当前页 默认0,回调之前会加1; 即callback(page)会从1开始
          size: 3 //每页数据条数,默认10
        },
        htmlLoading: '<p class="upwarp-tip">加载中..</p>'
      }
    };
  },
  methods: {
    blur() {
      setTimeout(function() {
        var scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop || 0;
        window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        console.log(1);
      }, 100);
    },
    next() {
      console.log("下一步");
      //判断表单数据
      let i;
      for (i = 0; i < this.$refs.ruleForm.length; i++) {
        this.$refs.ruleForm[i].validate(valid => {
          if (valid) {
            console.log(valid);
          } else {
            console.log("error submit!!");
            this.page = 1;
            e.stopPropagation();
            return false;
          }
        });
      }
      this.getOrder();
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    //获取历史订单
    getOrder() {
      // alert(this.getCookie("code"));
      if (this.getCookie("code") === undefined) {
        console.log("没有token");
        this.login();
      } else {
        console.log(this.getCookie("code"));
        // var _this = this;
        this.$axios
          .get(
            window.SITE_CONFIG.baseUrl +
              "/api/order/web/ticket/mine?page=" +
              this.currentPage +
              "&limit=" +
              this.pageSize +
              "&type=" +
              this.type +
              "&cancel=" +
              false,
            {
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: this.getCookie("code")
              }
            }
          )
          .then(response => {
            console.log(response);
            console.log(response.data.data);
            if (response.data.status === 40101) {
              this.login();
              // $.cookie("code", '', {expires:-1})
              // $.cookie("phoneNumber", '', {expires:-1})
            }
            if (response.data.rel === false) {
              alert(response.data.message);
            } else {
              // if (this.type === "noEnd") {
              //   this.noStartList = response.data.data.rows;
              // } else {
              //   this.endList = response.data.data.rows;
              // }
              console.log(response.data.data.rows);
              this.dataList = response.data.data.rows;

              this.page = "2";
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              console.log("submit!!");
            }
          });
      }
    },
    //获取验证码
    getVerificationCode() {
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/message/send/verification-code?phoneNumber=" +
            this.ruleForm.phoneNumber
        )
        .then(({ data }) => {
          // console.log(data);
          alert(data.data);
        });
      this.sendAuthCode = false;
      this.auth_time = 30;
      const auth_timetimer = setInterval(() => {
        this.auth_time--;
        if (this.auth_time <= 0) {
          this.sendAuthCode = true;
          clearInterval(auth_timetimer);
        }
      }, 1000);
    },
    switchHistory() {
      this.type = "end";
      this.history = true;
      this.isOpacity2 = "";
      this.isOpacity1 = "opacity";
    },
    switchNow() {
      this.type = "noEnd";
      this.history = false;
      this.isOpacity1 = "";
      this.isOpacity2 = "opacity";
    },
    //查看详情
    look(index) {
      console.log(index);
      this.page = "3";
      this.number = index;
    },
    //提醒弹窗
    remind() {
      this.remindShow = true;
      console.log(this.remindShow);
    },
    //取消预约
    cancelTicket() {
      this.$axios
        .put(
          window.SITE_CONFIG.baseUrl +
            "/api/order/web/ticket/cancel/" +
            this.dataList[this.number].ticketOrderId +
            "/" +
            this.dataList[this.number].ticketDate,
          {},
          {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              Authorization: this.getCookie("code")
            }
          }
        )
        .then(response => {
          console.log(response.data);
          console.log(response.data.message);
          this.getOrder();
          this.remindShow = false;
        });
    },
    //返回列表
    returnList() {
      this.page = "2";
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    getTicket() {
      this.qrcodeShow = true;
    },
    returnOrder() {
      this.qrcodeShow = false;
    },
    //读取登录缓存
    isLogin() {
      //判断是否有token
      if (
        this.getCookie("code") !== "" &&
        this.getCookie("code") !== undefined
      ) {
        // alert(this.getCookie("code"))
        this.page = "2";
        var _this = this;
        this.$axios
          .get(
            window.SITE_CONFIG.baseUrl +
              "/api/order/web/ticket/mine?page=" +
              this.currentPage +
              "&limit=" +
              this.pageSize +
              "&type=" +
              this.type +
              "&cancel=" +
              false,
            {
              headers: {
                "Content-Type": "application/json; charset=utf-8",
                Authorization: this.getCookie("code")
              }
            }
          )
          .then(response => {
            console.log(response);
            console.log(response.data.data);
            if (response.data.status === 40101) {
              _this.$cookie.delete("code");
              _this.$cookie.delete("phoneNumber");
              _this.page = "1";
              // $.cookie("code", '', {expires:-1})
              // $.cookie("phoneNumber", '', {expires:-1})
              // alert(_this.getCookie("code"))
            } else if (response.data.rel === false) {
              alert(response.data.message);
            } else {
              this.dataList = response.data.data.rows;
              this.page = "2";
              document.body.scrollTop = 0;
              document.documentElement.scrollTop = 0;
              console.log("submit!!");
            }
          });
      }
    },
    login() {
      var _this = this;
      this.$axios({
        method: "post",
        url: window.SITE_CONFIG.baseUrl + "/api/auth/jwt/member-token",
        headers: {
          "Content-Type": "application/json; charset=utf-8"
        },
        data: JSON.stringify({
          mobilePhone: this.ruleForm.phoneNumber,
          authCode: this.ruleForm.smsCode
        })
      }).then(function(response) {
        // alert(response.data);
        console.log(response.status);
        if (response.status === 200) {
          // document.cookie = "code" + "=" + response.data;
          // document.cookie =
          //   "phoneNumber" + "=" + _this.ruleForm.phoneNumber;
          console.log(_this.getCookie("code"));
          _this.setCookie("code", response.data);
          _this.setCookie("phoneNumber", _this.ruleForm.phoneNumber);
          var that = _this;
          _this.$axios
            .get(
              window.SITE_CONFIG.baseUrl +
                "/api/order/web/ticket/mine?page=" +
                _this.currentPage +
                "&limit=" +
                _this.pageSize +
                "&type=" +
                _this.type +
                "&cancel=" +
                false,
              {
                headers: {
                  "Content-Type": "application/json; charset=utf-8",
                  Authorization: _this.getCookie("code")
                }
              }
            )
            .then(response => {
              console.log(response);
              console.log(response.data.data);
              if (response.data.rel === false) {
                alert(response.data.message);
              } else {
                that.dataList = response.data.data.rows;
                that.page = "2";
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                console.log("submit!!");
              }
            });
        }
      });
    },
    getCookie: function(cookie_name) {
      var allcookies = document.cookie;
      //索引长度，开始索引的位置
      var cookie_pos = allcookies.indexOf(cookie_name);

      // 如果找到了索引，就代表cookie存在,否则不存在
      if (cookie_pos !== -1) {
        // 把cookie_pos放在值的开始，只要给值加1即可
        //计算取cookie值得开始索引，加的1为“=”
        cookie_pos = cookie_pos + cookie_name.length + 1;
        //计算取cookie值得结束索引
        var cookie_end = allcookies.indexOf(";", cookie_pos);

        if (cookie_end === -1) {
          cookie_end = allcookies.length;
        }
        //得到想要的cookie的值
        var value = unescape(allcookies.substring(cookie_pos, cookie_end));
      }
      return value;
    },
    //设置cookie时间以秒为单位
    setCookie(c_name, value, expireseconds) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + expireseconds * 1000);
      document.cookie =
        c_name +
        "=" +
        escape(value) +
        (expireseconds == null ? "" : ";expires=" + exdate.toGMTString()) +
        ";path=/";
    },
    mescrollInit(mescroll) {
      this.mescroll = mescroll; // 如果this.mescroll对象没有使用到,则mescrollInit可以不用配置
    },
    // 上拉回调 page = {num:1, size:10}; num:当前页 ,默认从1开始; size:每页数据条数,默认10
    upCallback(page, mescroll) {
      console.log(page);
      // 联网请求
      this.$axios
        .get(
          window.SITE_CONFIG.baseUrl +
            "/api/order/web/ticket/mine?page=" +
            page.num +
            "&limit=" +
            page.size +
            "&type=" +
            this.type +
            "&cancel=" +
            false,
          {
            headers: {
              "Content-Type": "application/json; charset=utf-8",
              Authorization: this.getCookie("code")
            }
          }
        )
        .then(response => {
          // 请求的列表数据
          let arr = response.data.data.rows;
          // 如果是第一页需手动置空列表
          if (page.num === 1) this.dataList = [];
          // 把请求到的数据添加到列表
          this.dataList = this.dataList.concat(arr);
          // 数据渲染成功后,隐藏下拉刷新的状态
          this.$nextTick(() => {
            mescroll.endSuccess(arr.length);
          });
        })
        .catch(function(e) {
          // 联网失败的回调,隐藏下拉刷新和上拉加载的状态;
          mescroll.endErr();
        });
    }
  },
  beforeMount() {
    this.isLogin();
  },
  mounted() {
    // this.isLogin();
  },
  watch: {
    type() {
      console.log(this.type);
      this.dataList = [];
      this.getOrder();
      this.mescroll.resetUpScroll();
      this.mescroll.scrollTo(0, 0);
    }
  }
};
</script>
<style lang="scss">
.mescroll {
  position: fixed;
  top: 2rem;
  left: 50%;
  margin-left: -600px;
  width: 1200px !important;
  bottom: 0;
  height: auto !important;
}
@media only screen and (min-width: 1280px) {
  .order-page .content .column {
    width: 100%;
    margin-top: 0.3rem;
  }
}
.yellow {
  color: #e6824d;
  display: inline-block !important;
}
/*通用样式*/
.opacity {
  opacity: 0.5;
}
/*登录页面*/
.login {
  width: 550px;
  margin: 0 auto;
  overflow: hidden;
  padding-top: 100px;
  > span {
    display: block;
    text-align: center;
    font-family: SourceHanSerifCN-SemiBold;
    letter-spacing: 0.161rem;
  }
  > span:first-child {
    font: {
      size: 36px;
    }
    color: #d0703d;
    // margin-top: 1rem;
  }
  > span:nth-child(2) {
    font: {
      size: 24px;
    }
    color: #666666;
    margin-bottom: 0.8rem;
  }
  .el-form {
    .info-list-item {
      background-color: #fff;
      height: 1.067rem;
      margin-bottom: 0.8rem;
      border-radius: 0.133rem;
      padding-left: 0.387rem;

      .el-form-item__content {
        width: 5.4rem;
        width: 280px;
        .el-input__inner {
          margin-left: 0;
        }
      }
      .info_icon1 {
        display: inline-block;
        top: 0.35rem;
      }
      .el-form-item__label {
        line-height: 1rem;
        height: 1rem;
      }
    }
  }
  .el-button {
    margin: 20px auto 0 auto;
    display: block;
  }
  .el-button--primary {
    background-image: linear-gradient(90deg, #a42f15, #eb8751),
      linear-gradient(0deg, #000, #fff);
    border: 0 solid red;
  }
}
/*订单页面*/

.tab {
  width: 1200px;
  height: 1.067rem;
  background-image: linear-gradient(90deg, #a42f15 0%, #eb8751 100%);
  position: fixed;
  z-index: 2;
  left: 50%;
  margin-left: -600px;
  span {
    color: #ffffff;
    font-size: 0.427rem;
    width: 49%;
    display: inline-block;
    text-align: center;
    line-height: 1.067rem;
    letter-spacing: 0.043rem;
  }
  span:nth-child(2) {
    width: 0.013rem;
    height: 0.52rem;
    background-color: #ffffff;
    border-color: #fff;
    /*vertical-align: text-bottom;*/
    position: absolute;
    top: 0.25rem;
  }
  /*订单详情页*/
  .order-details {
    width: 90%;
    margin: 0 auto;
  }
}
.order-page {
  .content {
    padding-top: 1.2rem;
    span {
      display: block;
    }
    .column {
      position: relative;
      top: 0;
      left: 0;
    }
    .museum-title {
      display: block;
      font-size: 0.4rem;
      line-height: 0.7rem;
      margin-top: 0.3rem;
      position: absolute;
      top: 0;
      right: 0.6rem;
      color: #666;
    }
    .time {
      font-size: 26px !important;
    }
    .details {
      width: 5.013rem;
      display: inline-block !important;
      color: #666;
      letter-spacing: 0.04rem;
      margin-top: 10px;
    }
    .button {
      float: right;
      display: inline-block;
      width: 2.48rem;
      height: 0.547rem;
      background-image: linear-gradient(90deg, #a42f15 0%, #eb8751 100%);
      border-radius: 0.273rem;
      margin: 0.1rem 0 0 0.5rem;
      font-size: 0.32rem;
      letter-spacing: 0.032rem;
      line-height: 0.547rem;
      text-align: center;
      color: #fff;
    }
    .disabled {
      background-color: #bbb;
      background-image: none;
    }
  }
}
.order-details {
  /*position: absolute;*/
  .qrcode {
    width: 0.5rem;
    height: 0.5rem;
    position: absolute;
    top: 2.5rem;
    right: 1rem;
  }
  .info_title {
    height: 1.15rem;
    line-height: 1.15rem;
  }
  .value {
    display: inline-block;
    height: 1.15rem;
    line-height: 1.15rem;
    width: 4rem;
    font-size: 0.3rem;
    color: #333;
  }
  .time {
    display: block;
    width: 63%;
    margin: 0.5rem auto 0 auto;
    font-size: 0.533rem;
    color: #e6824d;
    letter-spacing: 0.053rem;
  }
  .button-group {
    width: 6.92rem;
    height: 0.933rem;
    position: relative;
    bottom: -1rem;
    left: 50%;
    margin-left: -3.46rem;
    .button {
      display: inline-block;
      width: 2.667rem;
      margin: 0;
      background-image: linear-gradient(90deg, #a42f15 0%, #eb8751 100%);
      border-radius: 0.133rem;
      color: #fefffe;
      text-align: center;
      font-size: 0.3rem;
      line-height: 0.933rem;
    }
    .button:first-child {
      margin-right: 1.2rem;
    }
  }
  .position2 {
    bottom: -2.5rem;
    padding: 1rem 0 1.5rem 0;
  }
  .popup {
    span {
      &:nth-child(2) {
        display: block;
        width: 7.427rem;
        margin: 0.787rem auto 0.677rem auto;
        font-size: 0.427rem;
        color: #333333;
        line-height: 1rem;
        letter-spacing: 0.043rem;
      }
      &:nth-child(3) {
        display: block;
        width: 7.427rem;
        margin: 0.787rem auto 0.677rem auto;
        text-align: center;
        font-size: 0.427rem;
        color: #333333;
        line-height: 1rem;
        letter-spacing: 0.043rem;
      }
    }
    #qrcode {
      /*margin:1rem 0 2rem 2.2rem;*/
      margin: 1rem auto 0 auto;
      display: block;
      height: 320px;
      width: 300px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/myOrder.vue